import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex } from '@rebass/grid';
import {
  color,
  space,
  typography,
  layout,
  background,
  border,
  position,
  shadow,
  flexbox,
} from 'styled-system';

const StyledTitle = styled.p`
  margin-bottom: 0;
  ${color};
  ${space};
  ${typography};
  ${layout};
  ${background};
  ${border};
  ${position};
  ${shadow};
  ${flexbox};
`;

export const IconTitle = styled(Flex)`
  ${color};
  ${space};
  ${typography};
  ${layout};
  ${background};
  ${border};
  ${position};
  ${shadow};
  ${flexbox};
`;

// Styles for the TitleWithIcons inside the hero overlay
export const OverlayTitle = styled(IconTitle)`
  flex-direction: column;
  align-items: flex-start;
  line-height: 19px;

  ${StyledTitle} {
    font-size: 20px;
    margin: 0.5rem 0 0 0;
  }

  img {
    height: 38px;
    width: 38px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    flex-direction: row;
    ${StyledTitle} {
      margin: 0 0 0 0.5rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    @supports (width: auto) {
      img {
        width: auto;
      }
    }

    ${StyledTitle} {
      font-size: 22px;
    }
  }
`;

// Styles for all the cards with TitlesWithIcons
export const CardTitle = styled(IconTitle)`
  flex-direction: column;
  align-items: flex-start;
  line-height: 39px;

  ${StyledTitle} {
    font-size: 22px;
    margin: 25px 0;
    font-weight: ${themeGet('fontWeights.medium')};
  }

  img {
    height: 30px;
    width: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${StyledTitle} {
      font-size: 18px;
      margin: 15px 0 30px;
    }

    img {
      height: 35px;
      width: 35px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    ${StyledTitle} {
      font-size: 24px;
      margin: 20px 0 40px;
    }

    img {
      height: 40px;
      width: 40px;
    }
  }
`;

// Styles for the TitleWithIcon in the main menu
export const MenuTitle = styled(IconTitle)`
  flex-direction: row;
  align-items: center;
  line-height: 39px;

  ${StyledTitle} {
    font-size: 22px;
    margin-left: 0.75rem;
  }

  img {
    height: 17px;
    width: 17px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${StyledTitle} {
      font-size: 28px;
    }

    img {
      height: 28px;
      width: 28px;
    }
  }
`;

export const StaticTitle = styled(IconTitle)`
  flex-direction: row;
  align-items: center;
  line-height: 24px;
  font-weight: ${themeGet('fontWeights.bold')};
  margin-bottom: 0.5rem;
  max-width: 200px;

  ${StyledTitle} {
    font-size: 22px;
    margin-left: 0.75rem;
  }

  img {
    height: 44px;
    width: 44px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 1rem;
    line-height: 18px;
    max-width: 150px;

    ${StyledTitle} {
      font-size: 18px;
    }

    img {
      height: 34px;
      width: 34px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    margin-bottom: 0;
    line-height: 24px;
    max-width: 200px;

    ${StyledTitle} {
      font-size: 24px;
    }

    img {
      height: 53px;
      width: 53px;
    }
  }
`;

export default StyledTitle;
